import React from "react";
import { MainBackgroundWrapper } from "modules/non-protected-page/shared";
import { Pricing, PricingProvider } from "modules/payment/pricing";
import Faq, { useFaqList } from "modules/marketing-pages/front-page/faq";
import { Container } from "components/ui/container";
import { serverRoutes } from "client-server-shared/config/routes";
import { PageHeadTags } from "common/head-tags";
import { buildJsonLd } from "modules/marketing-pages/faq-to-json-ld";
import Script from "next/script";
import { useUserDetailsData } from "hooks/user-user-details-data";
import { SourceType } from "utils/tracking/type";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { locale } from "client-server-shared/constants";
import { useTranslation } from "components/translate";
import { Box } from "components/ui/box";
import PricingTable from "modules/payment/pricing-table";
import { useFetchUserDetailsDataOnlyOnce } from "hooks/user-user-details-data";
import { useUserFromShopify } from "hooks/use-user";
import { colors } from "src/constants";

const PricingSection = () => {
  return (
    <MainBackgroundWrapper
      component="section"
      sx={{
        padding: "72px 0 0 0",
        background: colors.white1,
      }}
    >
      <Container maxWidth="xl">
        <Pricing page={SourceType.PricingPage} />
      </Container>
    </MainBackgroundWrapper>
  );
};

export default function PricingPage() {
  useUserDetailsData();
  useFetchUserDetailsDataOnlyOnce();
  const { t } = useTranslation("pricing");
  const faqLists = useFaqList();
  const fromShopify = useUserFromShopify();

  if (fromShopify) {
    return (
      <Box
        sx={{
          height: "400px",
          textAlign: "center",
          padding: "72px",
        }}
      >
        Junia AI is free to use for Shopify users.
      </Box>
    );
  }

  return (
    <PricingProvider page={SourceType.PricingPage}>
      <PageHeadTags
        pageLink={serverRoutes.pricing}
        title={"Pricing - WritingTools.ai"}
        description={
          "Find the best pricing for writingtools.ai. Compare plans, features, and pricing to find the best fit for your business."
        }
      />
      <PricingSection />
      <Box
        component="section"
        sx={{
          background: "white",
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            padding: "72px 0 124px 0",
          }}
        >
          <PricingTable />
        </Container>
      </Box>
      <Faq />
      <Script
        id="pricing-faq"
        key="pricing-faq"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(buildJsonLd(faqLists)),
        }}
      />
    </PricingProvider>
  );
}

export async function getStaticProps() {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "pricing",
        "pricing-faq",
        "common",
      ])),
      // Will be passed to the page component as props
    },
  };
}
